const selectElements = document.querySelectorAll('[data-change-url]');

function initSelects() {
  const url = window.location.protocol + "//" + window.location.host + "/";

  function handleSelectChange({ currentTarget }) {
    const selectedOption = currentTarget[currentTarget.selectedIndex].value;

    if (selectedOption === '') {
      window.location.href = url + '/blog/';
    } else {
      window.location.href = url + '/categorie/' + selectedOption + '/';
    }
  }

  selectElements.forEach((select) => {
    select.addEventListener('change', handleSelectChange);
  });
}

if (selectElements.length) initSelects();
